import { OneFormContent } from 'src/feature-app';
import {
	CalculatorDefaultResponse,
	CalculatorFormatedSummaries,
} from 'src/types';
import { formatHeaders } from '../../format-fields';

export const getFinanceCalculation = async (faContent: OneFormContent) => {
	if (faContent.financeCalculation != undefined) {
		const calculatedFinanceRaw =
			faContent.financeCalculation as CalculatorDefaultResponse['rawResponse'];
		const formatedSummaries = formatSummaries(calculatedFinanceRaw);

		const headers = {
			FORM_NAME: 'vw-oneform-lead-oferta',
		};

		const ofertaCalculatedFields = {
			'fields[VEH_INTEREST_FINANCIAL_PRODUCT]':
				calculatedFinanceRaw.Response.Parameters.Description,
			'fields[VEH_INTEREST_OFFER_PRICE]': `${
				formatedSummaries.Full.Rate.Value + '€/mes'
			}`,
			'fields[VEH_INTEREST_OFFER_DETAIL]': formatOfferDetail(
				formatedSummaries,
				calculatedFinanceRaw.Response.Parameters.Description,
			),
		};
		return { ...formatHeaders(headers), ...ofertaCalculatedFields };
	}
	return null;
};

export function formatSummaries(
	response: CalculatorDefaultResponse['rawResponse'],
): CalculatorFormatedSummaries | undefined {
	const Summaries = response?.Response?.Result?.Summaries?.Summary.reduce(
		(acc: any, detail: any) => {
			acc[detail['@Type']] = detail;
			return acc;
		},
		{},
	);

	if (!Summaries) return undefined;

	Object.keys(Summaries).forEach(key => {
		const summary = Summaries[key];
		const details = summary?.DetailGroups?.DetailGroup?.Details?.Detail;

		if (details) {
			const detailsArray = Array.isArray(details) ? details : [details];
			Summaries[key] = detailsArray.reduce((acc, detail) => {
				acc[detail['@ID']] = detail;
				return acc;
			}, {});
		}
	});

	return Summaries;
}
export function formatOfferDetail(
	formatedSummaries: CalculatorFormatedSummaries,
	financialProduct: string,
): string {
	return (
		`${
			financialProduct == 'My Way'
				? 'Financiación ' + financialProduct
				: financialProduct
		} calculada por el usuario` +
		`\r\n* Entrada inicial: ${formatedSummaries.Full.DownPayment.Value} €` +
		`\r\n* Meses de financiación: ${formatedSummaries.Full.Duration.Value} Meses` +
		`${
			formatedSummaries.Full.Kilometers?.Value
				? `\r\n* Kilómetros anuales: ${formatedSummaries.Full.Kilometers.Value} km`
				: ''
		}` +
		`\r\n* Cuota: ${formatedSummaries.Full.Rate.Value} €` +
		`${
			formatedSummaries.Full.FinalRate?.Value
				? `\r\n* Cuota Final (Opcional): ${formatedSummaries.Full.FinalRate.Value} €`
				: ''
		}`
	);
}
